<template>
  <div class="page-con">
    <div class="page-con-header clearfix">
      <div class="finance-header">
        <span class="finance-span finance-span-time">
          <label>选择时间:</label>
          <DatePicker
              type="date"
              v-model="startTime"
              placeholder="请选择开始日期"
              style="width: 200px"
          ></DatePicker>
          <i class="line-icon">--</i>
          <DatePicker
              type="date"
              v-model="endTime"
              placeholder="请选择结束日期"
              style="width: 200px"
          ></DatePicker>
        </span>
        <span class="finance-span">
          <label>所属公司:</label>
          <Select
              style="width: 200px"
              v-model="searchCompany"
              multiple
              filterable
              prefix="ios-arrow-down"
              :remote-method="(file) => remoteMethod(file,'companyOptions','finance','cebTrade/getTradeBusiNum')"
              :default-label="[]"
              :loading="loading"
              :max-tag-count="1"
              :max-tag-placeholder="maxTagPlaceholder"
              @on-set-default-options="(file) =>setDefaultOptions(file,'companyOptions')"
              placeholder="请选择所属公司"
          >
            <Option
                v-for="option in companyOptions"
                :value="option.busiNum"
                :key="option.busiNum"
            >{{ option.subjectName }}</Option
            >
          </Select>
        </span>
        <span class="finance-span">
          <label>用户:</label>
          <Select
              style="width: 200px"
              v-model="searchSubject"
              multiple
              filterable
              prefix="ios-arrow-down"
              :remote-method="(file) => remoteMethod(file,'userOptions','finance','cebBusiMem/queryUserMem')"
              :default-label="userDefaultlabel"
              :loading="loading"
              :max-tag-count="1"
              :max-tag-placeholder="maxTagPlaceholder"
              @on-set-default-options="(file) =>setDefaultOptions(file,'userOptions')"
              placeholder="请选择用户"
          >
            <Option
                v-for="option in userOptions"
                :value="{subjectId:option.subjectId, subjectType:option.subjectType} | ObjectToString"
                :key="option.subjectId"
            >{{ option.subjectName }}</Option
            >
          </Select>
        </span>
        <!--        <span class="finance-span">-->
        <!--          <label>订单:</label>-->
        <!--          <Select-->
        <!--              style="width: 200px"-->
        <!--              v-model="searchOrder"-->
        <!--              multiple-->
        <!--              filterable-->
        <!--              prefix="ios-arrow-down"-->
        <!--              :remote-method="(file) => remoteMethod(file,'orderOptions','finance','cebTrade/getTradeOrderNum')"-->
        <!--              :default-label="[]"-->
        <!--              :loading="loading"-->
        <!--              :max-tag-count="1"-->
        <!--              :max-tag-placeholder="maxTagPlaceholder"-->
        <!--              @on-set-default-options="(file) =>setDefaultOptions(file,'accountOptions')"-->
        <!--              placeholder="请选择订单"-->
        <!--          >-->
        <!--            <Option-->
        <!--                v-for="option in orderOptions"-->
        <!--                :value="option.orderNum"-->
        <!--                :key="option.orderNum"-->
        <!--            >{{ option.orderNum }}</Option-->
        <!--            >-->
        <!--          </Select>-->
        <!--        </span>-->
      </div>
      <div class="finance-header" style="display: flex">
        <span class="finance-span">
          <label>客户:</label>
          <Select
              style="width: 200px"
              v-model="searchClient"
              multiple
              filterable
              prefix="ios-arrow-down"
              :remote-method="(file) => remoteMethod(file,'clientOptions','finance','cebTrade/getAllOtherName')"
              :default-label="[]"
              :loading="loading"
              :max-tag-count="1"
              :max-tag-placeholder="maxTagPlaceholder"
              @on-set-default-options="(file) =>setDefaultOptions(file,'clientOptions')"
              placeholder="请选择客户"
          >
            <Option
                v-for="option in clientOptions"
                :value="option.name"
                :key="option.name"
            >{{ option.name }}</Option
            >
          </Select>
        </span>
        <span class="finance-span">
          <label>客户账号:</label>
          <vxe-input
              v-model="searchAccount"
              @keyup.enter.native="search"
              placeholder="请输入客户账号"
              style="width: 200px"
          ></vxe-input>
        </span>
        <span class="finance-span">
          <Button status="primary" icon="ios-search" @click="search" style="border-radius: 5px;">搜索</Button>
          <Button @click="reset" style="margin-left: 10px;border-radius: 5px;">重置</Button>
          <Button status="primary" v-if="isHavePermission('financeUser:batchDownload')" @click="batchDownload(0)"
                  :style="isHavePermission('financeUser:batchDownload') ? 'margin-left: 10px;border-radius: 5px;':''">批量下载平台回单</Button>
          <Button status="primary" v-if="isHavePermission('financeUser:batchDownloadCeb')"
                  style="margin-left: 10px;border-radius: 5px;">
            <Dropdown
                trigger="click"
                style="  color: #666"
                transfer
            >
            批量下载光大回单
              <icon type="text" custom="iconfont icon-gengduo" size="12px"></icon>
              <DropdownMenu slot="list" style="left: 70px">
                <div style="display: flex; flex-direction: column">
                  <Button
                      class="button-gengduo"
                      @click="batchDownload(1)"
                  >导出pdf格式
                  </Button>
                  <Button
                      class="button-gengduo"
                      @click="batchDownload(1,1)"
                  >导出png格式
                  </Button>
                </div>
              </DropdownMenu>
            </Dropdown>
          </Button>
          <Button status="primary" @click="download" v-if="isHavePermission('financeUser:download')"
                  :style="isHavePermission('financeUser:download')? 'margin-left: 10px;border-radius: 5px;':''">明细导出</Button>
        </span>
        <span class="finance-span">
          <label>回单筛选</label>
          <vxe-select
              v-model="searchFile"
              :options="fileOptions"
              style="width: 120px"
          ></vxe-select>
        </span>
      </div>
    </div>
    <div class="list-box common-shadow clearfix">
      <vxe-table
          class="table-style"
          stripe
          highlight-hover-row
          show-footer
          show-overflow
          ref="xGrid"
          max-height="560"
          border="none"
          align="center"
          :loading="tableLoading"
          :data="dataList"
          :footer-method="footerMethod"
          resizable
      >
        <vxe-table-column field="id" title="序号" width="90">
        </vxe-table-column>
        <vxe-table-column title="操作" width="60">
          <template slot-scope="{ row }">
            <Dropdown trigger="click" transfer>
              <icon
                  type="text"
                  custom="iconfont icon-gengduo"
                  size="14px"
              ></icon>
              <DropdownMenu slot="list" style="left: 70px">
                <div style="display: flex; flex-direction: column">
                  <Button class="button-gengduo" @click="showPic(row.id, 0)">查看平台回单</Button>
                  <Button class="button-gengduo" @click="showPic(row.id, 1)">查看光大回单</Button>
                </div>
              </DropdownMenu>
            </Dropdown>
          </template>
        </vxe-table-column>
        <vxe-table-column field="procTimestamp" title="时间">
          <template slot-scope="{ row }">
            <span>{{ row.procTimestamp | timeFormatDateTime }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="busiSubjectName" title="所属公司"></vxe-table-column>
        <vxe-table-column field="memName" title="用户"></vxe-table-column>
        <vxe-table-column field="otherName" title="客户"></vxe-table-column>
        <vxe-table-column field="otherSubAcc" title="客户账号"></vxe-table-column>
        <vxe-table-column field="note" title="摘要"></vxe-table-column>
        <vxe-table-column field="inTradeAmount" title="借方（收入）">
          <template slot-scope="{ row }">
            <span>{{ row.inTradeAmount | numberToCurrency }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="outTradeAmount" title="贷方（支出）">
          <template slot-scope="{ row }">
            <span>{{ row.outTradeAmount | numberToCurrency }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="balance" title="余额">
          <template slot-scope="{ row }">
            <span>{{ row.balance | formatMoney }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <vxe-modal v-model="isShowPaymentDetail" width="1300" height="680" resize remember>
      <div slot="title">收付款详情</div>
      <payment-detail :cate="cate" :isShow="isShowPaymentDetail" ref="paymentDetail"
                      @close="isShowPaymentDetail = false"
      ></payment-detail>
    </vxe-modal>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import {getBlob, hideLoading, isEmpty, postBlob, saveBlob, showLoading} from "@/utils/util";
import {numberToCurrency} from "@/filters/type";
import viewOrderDetail from "@/mixin/viewOrderDetail";
import PaymentDetail from '@/views/payment/PaymentDetail.vue';
import moment from 'moment'
import getAuthOrization from "@/mixin/getAuthOrization";
import {apiPost} from "@/utils/api";

moment.locale('zh-CN')

export default {
  components: {PaymentDetail},
  mixins: [viewOrderDetail, getAuthOrization],
  data() {
    return {
      fileOptions: [{
        label: '全部',
        value: null
      }, {
        label: '有光大回单',
        value: 1
      }, {
        label: '无光大回单',
        value: 0
      },],
      cate: 'Payment',
      loading: false,
      tableLoading: false,
      dataList: [],
      page: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 0,
      },
      searchAccount: '',
      searchFile: null,
      searchSubject: [],
      searchCompany: [],
      searchOrder: [],
      searchClient: [],
      userOptions: [],
      companyOptions: [],
      orderOptions: [],
      clientOptions: [],
      userDefaultlabel: [],
      startTime: '',
      endTime: '',
      isShowCollectionDetail: false,
      isShowPaymentDetail: false,
      paramsObj: {}
    };
  },
  filters: {
    ObjectToString: str => {
      return JSON.stringify(str)
    }
  },
  watch: {
    $route(to, from) {
      if (to.path === "/finance/user") {
        this.init();
      }
    },
  },
  activated() {
    this.init();
  },
  mounted() {
    this.$bus.$on("用户子账户明细", () => {
      this.reset();
      this.startTime = moment().startOf("day").format("YYYY-MM-DD 00:00:00");
      this.endTime = moment().endOf('day').format("YYYY-MM-DD 23:59:59");
    });
    this.startTime = moment().startOf("day").format("YYYY-MM-DD 00:00:00");
    this.endTime = moment().endOf('day').format("YYYY-MM-DD 23:59:59");
  },
  methods: {
    async download() {
      if (isEmpty(this.dataList)) {
        this.$XModal.message("请先搜索数据");
        return;
      }
      let params = this.paramsObj;
      showLoading();
      let res = postBlob("/api/finance/cebTradeExport/exportTradeDetail", params);
      hideLoading();
      await saveBlob("明细导出.xls", res.data);
    },
    async batchDownload(sourceType, exportToPng) {
      if (isEmpty(this.dataList)) {
        this.$XModal.message("请先搜索数据");
        return;
      }
      let params = this.paramsObj;
      params.sourceType = sourceType
      params.exportToPng = exportToPng
      showLoading();
      let res = postBlob('/api/finance/cebTradeExport/exportTradeDetailImage', params)
      hideLoading();
      await saveBlob(".zip", res.data)
    },
    async showPic(id, source) {
      let res = await apiPost("api/finance", "/cebFile/findVoucherFile", {id, source})
      if (res.data && res.data.length > 0) {
        let fileRes = await apiPost("api/tool", "/oss/getUrlListPost", [res.data[0].fileUuid])
        window.open(fileRes[0].url);
      } else {
        this.$XModal.alert({
          message: '暂无回单信息',
          status: "error",
        });
      }
    },
    viewDetail(row) {
      this.isShowPaymentDetail = true;
      this.$refs.paymentDetail.setEdit(false);
      this.$refs.paymentDetail.init(row.paymentsId);
    },
    async init() {
      if (this.$route.query.subjectId || this.$route.query.busiNum) {
        await this.getList('', 'userOptions', 'finance', 'cebBusiMem/queryUserMem');
        await this.getList('', 'companyOptions', 'finance', 'cebTrade/getTradeBusiNum');
        await this.getList('', 'clientOptions', 'finance', 'cebTrade/getAllOtherName');
        if (this.$route.query.subjectId) {
          let obj = {
            subjectId: parseInt(this.$route.query.subjectId),
            subjectType: parseInt(this.$route.query.subjectType)
          };
          this.searchSubject = [JSON.stringify(obj)];
        }
        if (this.$route.query.busiNum) {
          this.searchCompany = [this.$route.query.busiNum];
        }
      }
    },
    async openOrder(num) {
      let res = await $api.ordersSeller.post("queryOrdersInfo/" + num);
      if (res.status === 1) {
        let data = res.data;
        this.openOrderDetail(data.orderId, data.orderType)
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    reset() {
      this.startTime = '';
      this.endTime = '';
      this.searchAccount = null;
      this.searchSubject = [];
      this.searchCompany = [];
      this.searchOrder = [];
      this.searchClient = [];
      this.dataList = [];
      this.searchFile = null;
    },
    maxTagPlaceholder(num) {
      return "更多+ " + num;
    },
    async getList(query, options, url, path) {
      let params = {};

      if (!isEmpty(query)) {
        params.word = query;
      }
      if (isEmpty(this[options])) {
        this.loading = true;
      }
      let res = await $api[url].post(path, params);
      this.loading = false;
      if (res.status === 1) {
        this[options] = res.data;
      }
    },
    remoteMethod(query, options, url, path) {
      if (query !== "") {
        this.loading = true;
        this.getList(query, options, url, path);
      } else {
        this[options] = [];
      }
    },
    setDefaultOptions(options, option) {
      this[option] = options;
    },
    search() {
      this.page.currentPage = 1;
      this.page.pageSize = 100000;
      if (this.endTime === '' && this.startTime === '' && !this.searchAccount && this.searchSubject.length === 0 && this.searchCompany.length === 0 && this.searchOrder.length === 0 && this.searchClient.length === 0) {
        this.$XModal.alert({
          message: "请输入搜索条件",
          status: "error",
        });
        return
      }
      this.getTradeList();
    },
    refresh() {
      this.getTradeList();
    },
    footerMethod({columns, data}) {
      const sums = [];
      columns.forEach((column, columnIndex) => {
        if (columnIndex === 0) {
          sums.push('合计')
        } else {
          let sumCell = null
          switch (column.property) {
            case 'inTradeAmount':
              sumCell = numberToCurrency(this.$utils.sum(data, column.property));
              break
            case 'outTradeAmount':
              sumCell = numberToCurrency(this.$utils.sum(data, column.property));
              break
          }
          sums.push(sumCell)
        }
      })
      // 返回一个二维数组的表尾合计
      return [sums]
    },
    handlePageChange(e) {
      this.page.currentPage = e.currentPage;
      this.page.pageSize = e.pageSize;
      this.getTradeList();
    },
    async getTradeList() {

      let searchSubject = [];
      if (this.searchSubject.length > 0) {
        this.searchSubject.map(i => {
          searchSubject.push(JSON.parse(i));
        })
      }
      this.paramsObj = {
        page: this.page.currentPage,
        rows: this.page.pageSize,
        orderBy: 2,
        subjectType: 1,
        otherSubAcc: this.searchAccount,
        virAccTypeList: ["99"],
        subjectList: searchSubject,
        busiNumList: this.searchCompany,
        orderNumList: this.searchOrder,
        otherNameList: this.searchClient,
        isHavFile: this.searchFile,
        startTime: this.startTime === '' ? this.startTime : this.$utils.timestamp(this.startTime),
        endTime: this.endTime === '' ? this.endTime : (this.$utils.timestamp(this.endTime) + 86399000)
      };
      if (!isEmpty(this.paramsObj.subjectList) && isEmpty(this.paramsObj.busiNumList)) {
        this.$XModal.message("请选择所属公司");
        return;
      }
      this.tableLoading = true;
      let res = await $api.finance.post("cebTrade/getTradeDetail", this.paramsObj);
      this.tableLoading = false;
      if (res.status === 1) {
        let data = res.data.rows;
        this.page.totalResult = res.data.total;
        data.map(i => {
          if (i.addReduce === '1') {
            i.inTradeAmount = i.tradeAmount;
          } else {
            i.outTradeAmount = i.tradeAmount;
          }
          i.note = i.note && i.note !== '' ? i.note : i.brief
        })
        this.dataList = data;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
  },
};
</script>

<style>
.finance-header .finance-span {
  display: inline-block;
  padding-right: 10px;
  margin-bottom: 10px;
}

.finance-span-time .line-icon {
  display: inline-block;
  width: 52px;
  text-align: center;
}

.finance-header label {
  display: inline-block;
  padding: 0 5px;
  color: #999;
}

.finance-header .vxe-input--inner,
.finance-header .ivu-input,
.finance-header .ivu-select-selection {
  border-radius: 0;
  border: 1px solid #dcdee2;
  height: 34px;
  box-sizing: border-box;
}

.finance-header .ivu-select {
  width: 320px;
  height: 34px;
  overflow: hidden;
}

.finance-header .ivu-select-multiple .ivu-tag,
.finance-header .ivu-select-input {
  display: inline-block;
  float: left;
}

.finance-header .ivu-select-default.ivu-select-multiple .ivu-select-selection {
  max-height: 32px;
  border-radius: 0;
}

.finance-header .ivu-select-prefix i {
  vertical-align: middle;
  position: absolute;
  right: 8px;
  top: 8px;
}
</style>
